import { Col, Row, Typography, Spin, Flex } from "antd";
import { useIntl } from "react-intl";
import UploadForm from "../../Common/Components/UploadForm";
import { useFetchSeason } from "../../entities/api";
import EditSeasonForm from "./EditSeasonForm";
import EditSeasonFormWrapper from "./EditSeasonFormWrapper";
import { PromotionRelegationRules } from "~Features/EditSeason/components/PromotionRelegationRules/PromotionRelegationRules";
import { useSportConfiguration } from "~hooks/useSportConfiguration.js";
import {PermissionNames} from "~enums/permissions.ts";

const EditSeason = () => {
  const { formatMessage } = useIntl();
  const { data: current, isLoading } = useFetchSeason({
    include: "organizations,fixtures,entities,fixtureProfiles,standingConfigurations,leaderCriteria",
  });

  const {
    uiConfiguration
  } = useSportConfiguration();
  const { seasonUpsert: seasonUpsertUiConfiguration } = uiConfiguration.pages;

  return (
    <>
      {isLoading && <Flex justify="center" style={{ marginTop: "4em" }}><Spin size="default" /></Flex>}
      {current && (
        <>
          <Typography.Title level={4}>
            {formatMessage({
              id: "season.update",
              defaultMessage: "Update Season",
            })}
          </Typography.Title>
          <Row>
            <Col span={14}>
              {current && (
                <EditSeasonFormWrapper seasonData={current}>
                  <EditSeasonForm reloadData={() => {}} />
                </EditSeasonFormWrapper>
              )}
            </Col>
            <Col span={10}>
              <UploadForm
                imageType="LOGO"
                dataId={current?.data?.[0]?.seasonId}
                image={current?.data?.[0]?.images?.[0]}
                imageFor="SEASON"
                permissionKey={PermissionNames.SEASON}
              />
              {seasonUpsertUiConfiguration.promotionRelegationRules.enabled && (
                <PromotionRelegationRules season={current?.data?.[0]} />
              )}
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default EditSeason;
